export default "__VITE_ASSET__CWg$ipGo__"